export const isObligationPortfolioResponse = (value) => {
    if (typeof value !== 'object' || value === null)
        return false;
    const r = value;
    return (r.currency === 'USD' &&
        typeof r.totalAmount === 'string' &&
        Number.isInteger(r.page) &&
        Number.isInteger(r.pageSize) &&
        Number.isInteger(r.totalItems) &&
        Number.isInteger(r.totalPages) &&
        Array.isArray(r.items) &&
        r.items.every((raw) => {
            if (typeof raw !== 'object' || raw === null)
                return false;
            const i = raw;
            return (typeof i.id === 'string' &&
                typeof i.memberName === 'string' &&
                typeof i.conceptName === 'string' &&
                /^\d{4}-(0[1-9]|1[0-2])$/.test(i.period ?? '') &&
                /^\d+\.\d{2}$/.test(i.amount ?? '') &&
                i.currency === 'USD' &&
                i.state === 'confirmed');
        }));
};
